export default "<div\n  id=\"map-canvas\"\n  class=\"relative w-full rounded h-600-px\"\n  data-lat=\"40.748817\"\n  data-lng=\"-73.985428\"\n></div>\n";